
$(function () {
    var elements = document.querySelectorAll('.yn-package-comparison .toggle-features');
    if (elements) {
        Object.keys(elements).forEach(function (key) {
            var currentItem = elements[key];
            currentItem.addEventListener("click", function (e) {
                e.target.classList.toggle('show-attributes')
                //this.closest('.main-nav--sub').classList.remove('visible');
            });
        });
    }
});
